import React from "react";

export function Marquee({ items = [], className = "", speed = 44, separator = "✦" }) {
  const strip = (
    <div className="flex items-center gap-14 pr-14 whitespace-nowrap">
      {items.map((t, i) => (
        <span key={i} className="serif italic text-4xl md:text-6xl text-[hsl(var(--navy))] flex items-center gap-14">
          <span>{t}</span>
          <span className="text-gold not-italic text-2xl md:text-3xl">{separator}</span>
        </span>
      ))}
    </div>
  );
  return (
    <div
      className={`overflow-hidden py-10 border-y hairline bg-[hsl(var(--ivory))] ${className}`}
      style={{ ["--marquee-speed"]: `${speed}s` }}
    >
      <div className="marquee-track flex w-max" style={{ animationDuration: `${speed}s` }}>
        {strip}
        {strip}
      </div>
    </div>
  );
}
